
<nz-layout class="layout layout-root">
  <nz-header class="header-wrapper header-gradient" nz-col nzSpan="24" *ngIf="!isDialog">
    <i *ngIf="winWidth" class="trigger pc-tab" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
      (click)="toggleCollapse()"></i>
    <i class="trigger mob" nz-icon [nzType]="isOpen ? 'menu-unfold' : 'menu-fold'" (click)="open()"></i>
    <app-header></app-header>
    <div class="menu-header-wrapper"> 
      <div class="left-arrow" *ngIf="menuItems.length > 5">
        <a (click)="scrollLeft()"><i nz-icon nzType="left" nzTheme="outline"></i></a>
      </div>
      <div *ngIf="!isDialog" class="menu-nav-wrap">
        <ul nz-menu #widgetsContent class="app-menu middle" [nzTheme]="'light'" [nzMode]="'horizontal'" #tabsContent>
          <li nz-menu-item id="{{ menuItem.label }}" [ngClass]="['app-menu-item']" *ngFor="let menuItem of menuItems"
            (click)="traverseToModule(menuItem)" [nzSelected]="menuItem.selected">
            <img class="menu-icon" width="20" height="20" [src]="'assets/img/icon/' + menuItem.label + '.svg'" [alt]="menuItem.icon"/>
            {{ menuItem.label | translate }}
          </li>
        </ul>
      </div>
      <div class="right-arrow" *ngIf="menuItems.length > 5 && !isDialog">
        <a (click)="scrollRight()">
          <i nz-icon nzType="right" nzTheme="outline"></i></a>
      </div>
    </div>
  </nz-header>
  <div class="sider-layout-wrapper">
    <nz-sider class="nav-sider" *ngIf="showSubMenu" nzCollapsible [(nzCollapsed)]="isCollapsed" [nzTrigger]="triggerTemplate" [ngClass]="{'hover-expanded': isHoverExpanded}" (mouseenter)="onSiderHover()" (mouseleave)="onSiderLeave()">
      <ul nz-menu class="sub-menu" [nzMode]="'inline'" nzTheme="light" [nzInlineCollapsed]="isCollapsed && !isHoverExpanded">
        <ng-container *ngFor="let menuItem of selectedModule?.children">
          <li id="{{ menuItem.label }}" nz-menu-item nz-tooltip nzTooltipTitle="{{ menuItem.label | translate }}"
            nzTooltipPlacement="right" class="sub-menu-item" *ngIf="
                      menuItem.children === undefined ||
                        menuItem.children.length === 0;
                      else subMenuWithChild
                    " (click)="traverseSubMenu(menuItem)" [nzSelected]="menuItem.selected" [hidden]="menuItem.hide">
            <span title>
              <img *ngIf="getMenuIcon(menuItem.label)" [src]="getMenuIcon(menuItem.label)" class="menu-icon" width="20" height="20" />
              <i *ngIf="!getMenuIcon(menuItem.label)" nz-icon [nzType]="menuItem.icon"></i>
              <span class="nav-text">{{ menuItem.label | translate }}</span>
            </span>
          </li>

          <ng-template #subMenuWithChild>
            <li id="{{ menuItem.label }}" nz-submenu nz-tooltip [nzOpen]="menuItem.selected && (!isCollapsed || isHoverExpanded)" (nzOpenChange)="menuItem.selected = $event" [hidden]="menuItem.hide">
              <span class="sub-menu-child" title nz-tooltip nzTooltipTitle="{{ menuItem.label | translate }}"
                nzTooltipPlacement="right">
                <img *ngIf="getMenuIcon(menuItem.label)" [src]="getMenuIcon(menuItem.label)" class="menu-icon" width="20" height="20" />
                <i *ngIf="!getMenuIcon(menuItem.label)" nz-icon [nzType]="menuItem.icon"></i>
                <span class="ttip" *ngIf="!isCollapsed || isHoverExpanded">{{ menuItem.label | translate }}</span>
              </span>
              <ul class="child-menu">
                <li id="{{ menuItem.label + '.' + childMenu.label }}" *ngFor="let childMenu of menuItem.children"
                  nz-menu-item nz-tooltip nzTooltipTitle="{{ childMenu.label | translate }}" nzTooltipPlacement="right"
                  [nzSelected]="childMenu.selected" [hidden]="childMenu.hide" [nzMatchRouter]="true">
                  <img *ngIf="getMenuIcon(childMenu.label)" [src]="getMenuIcon(childMenu.label)" class="menu-icon" width="14" height="14" />
                  <i *ngIf="!getMenuIcon(childMenu.label)" nz-icon [nzType]="childMenu.icon"></i>
                  <span class="ttip">
                    <a [routerLink]="selectedModule.link + menuItem.link +childMenu.link">{{ childMenu.label | translate
                      }}</a>
                  </span>
                </li>
              </ul>
            </li>
          </ng-template>
        </ng-container>
      </ul>
    </nz-sider>
    <nz-layout class="layout app-menu-container">

      <nz-content class="app-menu-content">
        <nz-layout class="sub-menu-container">

          <nz-content class="router-content" [ngClass]="{
                'full-width-content': selectedModule?.children?.length === 0 || selectedModule === undefined }">
            <nz-skeleton [nzActive]="true" [nzLoading]="false">
              <div *ngIf="showMessage" [@slideInOut] class="mb-lg mob-mb-lg">
                <nz-alert *ngIf="errorMessages && errorMessages.length > 0" nzType="error" nzCloseable nzShowIcon
                  [nzMessage]="
                      errorMessages.length > 1 ? multipleErrorData : errorData
                    " (nzOnClose)="afterClose()">
                </nz-alert>
                <ng-template #errorData>{{ errorMessages[0] }}</ng-template>
                <ng-template #multipleErrorData>
                  Multiple errors encountered.
                  <a class="error-link" (click)="openError()">Click here to view</a>
                </ng-template>
                <nz-alert *ngIf="successMessage" nzType="success" nzCloseable nzShowIcon nzMessage="{{ successMessage }}"
                  (nzOnClose)="afterClose()">
                </nz-alert>
              </div>
              <router-outlet (activate)="onActivate($event)"></router-outlet>
            </nz-skeleton>
          </nz-content>
          <div class="footer-div" *ngIf="!isDialog">
            <app-footer></app-footer>
          </div>
        </nz-layout>
      </nz-content>
    </nz-layout>
  </div>

  </nz-layout>

<!-- <app-build-info-button *ngIf="!isDialog"></app-build-info-button> -->

<!-- <nz-modal [(nzVisible)]="loadingCheck" [nzFooter]="null" nzClosable="false" >
  <ng-container *nzModalContent>
    <nz-spin nzSimple [nzSize]="'large'" nzTip="RDM LOADING!!!!!" style=" text-align: center"></nz-spin>
  </ng-container>
</nz-modal> -->

<nz-drawer [nzClosable]="false" [nzVisible]="visible" nzPlacement="right" nzTitle="Error Messages"
  (nzOnClose)="close()">
  <ng-container *nzDrawerContent>
    <p *ngFor="let msg of errorMessages">{{ msg }}</p>
  </ng-container>

</nz-drawer>
<nz-drawer [nzClosable]="true" [nzVisible]="isOpen" nzPlacement="left" nzTitle="Menu" (nzOnClose)="close()"
  [nzWrapClassName]="'leftmenu'">
  <ng-container *nzDrawerContent>
  <ul nz-menu [nzTheme]="'light'" [nzMode]="'inline'">
    <ng-container *ngFor="let menuItem of menuItems">
      <li [ngClass]="[menuItem.label]" nz-menu-item nzPlacement="right" *ngIf="
          menuItem.children && menuItem.children.length === 0;
          else mainMenuWithChild
        " (click)="onMainMenu(menuItem)">
        <span title>
          <img *ngIf="getMenuIcon(menuItem.label)" [src]="getMenuIcon(menuItem.label)" class="menu-icon" width="20" height="20" />
          <i *ngIf="!getMenuIcon(menuItem.label)" nz-icon [nzType]="menuItem.icon"></i>
          {{ menuItem.label | translate }}
        </span>
      </li>
      <ng-template #mainMenuWithChild>
        <li [ngClass]="[menuItem.label, 'sub-menu-item']" nz-submenu (click)="onMainMenu(menuItem)"
          [(nzOpen)]="menuItem.open">
          <span title>
            <img *ngIf="getMenuIcon(menuItem.label)" [src]="getMenuIcon(menuItem.label)" class="menu-icon" width="20" height="20" />
            <i *ngIf="!getMenuIcon(menuItem.label)" nz-icon [nzType]="menuItem.icon"></i>
            <span class="ttip">{{menuItem.label | translate}}</span>
          </span><ul>
            <ng-container *ngFor="let subMenuItem of menuService.getSubMenu()">
              <li [ngClass]="[subMenuItem.label]" nz-menu-item nzPlacement="right" *ngIf="
                  subMenuItem.children && subMenuItem.children.length === 0;
                  else subMenuWithChild
                " (click)="onSubMenu(subMenuItem)">
                <span title>
                  <img *ngIf="getMenuIcon(subMenuItem.label)" [src]="getMenuIcon(subMenuItem.label)" class="menu-icon" width="20" height="20" />
                  <i *ngIf="!getMenuIcon(subMenuItem.label)" nz-icon [nzType]="subMenuItem.icon"></i>
                  <span class="ttip">{{subMenuItem.label | translate}}</span>
                </span>
              </li>
              <ng-template #subMenuWithChild>
                <li [ngClass]="[subMenuItem.label, 'sub-menu-item']" nz-submenu>
                  <span title>
                    <img *ngIf="getMenuIcon(subMenuItem.label)" [src]="getMenuIcon(subMenuItem.label)" class="menu-icon" width="20" height="20" />
                    <i *ngIf="!getMenuIcon(subMenuItem.label)" nz-icon [nzType]="subMenuItem.icon"></i>
                    <span class="ttip">{{subMenuItem.label | translate}}</span>
                  </span>
                  <ul>
                    <ng-container *ngFor="let childMenuItem of subMenuItem.children">
                      <li [ngClass]="[childMenuItem.label]" nz-menu-item nzPlacement="right" *ngIf="
                          childMenuItem.children &&
                          childMenuItem.children.length === 0
                        " (click)="onChildMenu(subMenuItem, childMenuItem)">
                        <span title>
                          <img *ngIf="getMenuIcon(childMenuItem.label)" [src]="getMenuIcon(childMenuItem.label)" class="menu-icon" width="14" height="14" />
                          <i *ngIf="!getMenuIcon(childMenuItem.label)" nz-icon [nzType]="childMenuItem.icon"></i>
                          <span class="ttip">{{childMenuItem.label | translate}}</span>
                        </span>
                      </li>
                    </ng-container>
                  </ul>
                </li>
              </ng-template>
            </ng-container>
          </ul>
        </li>
      </ng-template>
    </ng-container>
  </ul>
</ng-container>
</nz-drawer>